export const environment = {
  production: false,
  apiBaseUrl: 'https://wpam-api.staging.web.plus/',
  auth: {
    tokenKey: 'auth_token',
    userKey: 'auth_user',
    expiryKey: 'auth_expiry',
    roleKey: 'auth_role',
    defaultTokenType: 'Bearer',
  },
};
